export default __webpack_public_path__ + "static/media/background.711d5f07.jpg";